export class Note {

    public id: number;
    public noteId: number;
    public notePriorityTypeID: number;
    public noteReceivedTypeID: number;
    public noteShortDescription: string;
    public noteDescription: string;
    public isConfidential = false;
    public isOIGFraud = false;
    public isAlert: boolean;
    public noteDate: Date;
    public updatedBy: string;
    public updatedDate: any;
    public businessUnit: string;
}
